import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import axiosConfig from '../../../configs/axios.config'
// Reducer Thunk
export const getKeepStock = createAsyncThunk('keepStock/getKeepStock', async () => {
    try {
        let response
        let docList

        const req = { GrpID: "", isAll: 0, UserId: 1, ItemCode: "", CheckGiuHang: 1 }
        response = await axios.create(axiosConfig).post(`api/report/keepStock`, req)
        if (response.data.success) {

            docList = response.data.result
        }
        else {
            console.log(response.data)
        }
        return (docList)
    }
    catch (error) {
        console.log(error)
        return []
    }

})

const keepStockSlice = createSlice({
    name: 'keepStock',
    initialState: {
        allPageLoad: [],
        Loading: true
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(getKeepStock.pending, (state, action) => {
            console.log('Fetching todos from backend ....')
            state.Loading = true
        })
        builder.addCase(getKeepStock.fulfilled, (state, action) => {
            console.log('Done')
            state.allPageLoad = action.payload
            state.Loading = false
        })
        builder.addCase(getKeepStock.rejected, (state, action) => {
            console.log('Failed to get todos!!!')
            state.Loading = false
        })
    }
})

// Reducer
const KeepStockReducer = keepStockSlice.reducer

// Selector
export const KeepStockSelector = (state) => state.KeepStockReducer
// Action export
export const {
} = keepStockSlice.actions

// Export reducer
export default KeepStockReducer